// Para carga dinámica pura, no necesitamos initFederation
// Los remotes se cargarán bajo demanda desde el FederationService
import('./bootstrap')
  .then(() => {})
  .catch((err) => {
    console.error('[Shell] ❌ Error cargando bootstrap:', err);
    console.error('[Shell] Stack:', err.stack);
  });



